import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { openModalBottom, openModal } from './ui';

export const startLoadSuscripcionActiva = (empresaId) => {
  return async (dispatch) => {
    try {
      const resp = await fetchConToken(`suscripciones/activa/${empresaId}`, {}, 'GET');
      
      if (resp.status === 404) {
        return;
      }

      const body = await resp.json();

      if (body.ok) {
        dispatch(setSuscripcionActiva(body.suscripcion));
      } else {
        dispatch(openModal({
          title: 'Error',
          text: [body.msg || 'No se pudo cargar la suscripción activa'],
          buttonText: 'Cerrar',
        }));
      }
    } catch (error) {
      console.error('Error cargando suscripción activa:', error);
    }
  }
};

export const setSuscripcionActiva = (suscripcion) => ({
  type: types.suscripcionLoad,
  payload: suscripcion,
});

export const startLoadSuscripcionCompleta = (suscripcionId) => {
  return async (dispatch) => {
    try {
      const resp = await fetchConToken(`suscripciones/${suscripcionId}`);
      const body = await resp.json();

      if (body.ok) {
        dispatch(setEmpresaSuscripcion(body.suscripcion.empresa));
      } else {
        dispatch(openModalBottom({ text: ['Error cargando suscripción'], timeOut: 3 }));
      }
    } catch (error) {
      console.error('Error obteniendo suscripción completa:', error);
      dispatch(openModalBottom({ text: ['Error cargando suscripción'], timeOut: 3 }));
    }
  }
};

export const setEmpresaSuscripcion = (empresa) => ({
  type: types.empresaSuscripcionLoaded,
  payload: empresa
});

export const startLoadProfesionalesActivos = (empresaId) => {
  return async (dispatch) => {
    try {
      const res = await fetchConToken('empresas/profesionales', { id: empresaId }, 'POST');
      const data = await res.json();

      if (data.ok && typeof data.profesionalesCount === 'number') {
        dispatch(setProfesionalesActivos(data.profesionalesCount));
      } else {
        dispatch(openModalBottom({ text: ['Error cargando profesionales activos'], timeOut: 3 }));
      }
    } catch (err) {
      console.error('Error cargando profesionales activos:', err);
      dispatch(openModalBottom({ text: ['Error cargando profesionales activos'], timeOut: 3 }));
    }
  }
};

export const setProfesionalesActivos = (count) => ({
  type: types.profesionalesActivosSet,
  payload: count
});

const mapCardBrand = (brand) => {
  if (!brand) return null;
  
  const brandMap = {
    'visa': 'VISA',
    'mastercard': 'MASTERCARD',
    'amex': 'AMEX',
    'american express': 'AMEX',
    'discover': 'DISCOVER',
    'jcb': 'JCB',
    'maestro': 'MAESTRO',
    'diners': 'DINERS CLUB',
    'diners club': 'DINERS CLUB',
    'unionpay': 'UNIONPAY'
  };
  
  const normalizedBrand = brand.toLowerCase().trim();
  return brandMap[normalizedBrand] || brand.toUpperCase();
};

const detectCardTypeFromBin = (bin) => {
  if (!bin) return null;
  
  const patterns = {
    'visa': /^4/,
    'mastercard': /^5[1-5]|^2[2-7]/,
    'amex': /^3[47]/,
    'discover': /^6(?:011|5)/,
    'jcb': /^(?:2131|1800|35)/,
    'maestro': /^(5018|5020|5038|6304|6759|6761|6763)/,
    'diners': /^3(?:0[0-5]|[68])/
  };
  
  for (const [brand, pattern] of Object.entries(patterns)) {
    if (pattern.test(bin)) {
      return brand.toUpperCase();
    }
  }
  
  return null;
};

export const startLoadTarjeta = (empresaId) => {
  return async (dispatch) => {
    try {
      const res = await fetchConToken(`pasarela/get-tarjeta-con-fallback/${empresaId}`);
      const result = await res.json();
      
      if (result.ok && result.data.cards?.length > 0) {
        const card = result.data.cards[0];
        
        const expireMonth = card.expire_month || card.expiryMonth || '??';
        const expireYear = card.expire_year || card.expiryYear || '??';
        const brand = detectCardTypeFromBin(card.bin);

        dispatch(setTarjeta({
          tipo: brand,
          numero: `**** **** **** ${card.last4 || '0000'}`,
          expiracion: `${expireMonth}/${expireYear}`,
          estado: 'activa',
        }));
      } else {
        dispatch(setTarjeta(null));
      }
    } catch (err) {
      console.error('Error al obtener los datos de la tarjeta:', err);
      dispatch(openModalBottom({ text: ['Error al obtener datos de tarjeta'], timeOut: 3 }));
      dispatch(setTarjeta(null));
    }
  };
};

export const setTarjeta = (tarjeta) => ({
  type: types.tarjetaSet,
  payload: tarjeta
});

export const startCancelarSuscripcion = (suscripcionId, empresaId) => {
  return async (dispatch) => {
    try {
      const resp = await fetchConToken(`suscripciones/${suscripcionId}/cancelar`, {}, 'PUT');
      const body = await resp.json();

      if (body.ok) {
        dispatch(openModalBottom({
          text: [body.msg || 'La suscripción se cancelará al final del período actual. Seguirás teniendo acceso hasta entonces.'],
          timeOut: 5
        }));
        
        if (body.suscripcion) {
          dispatch(setSuscripcionActiva(body.suscripcion));
        } else if (empresaId) {
          dispatch(startLoadSuscripcionActiva(empresaId));
        }
      } else {
        dispatch(openModalBottom({
          text: [body.msg || 'Error al cancelar la suscripción'],
          timeOut: 4
        }));
      }
    } catch (error) {
      console.error('Error cancelando suscripción:', error);
      dispatch(openModalBottom({
        text: ['Error al cancelar la suscripción. Por favor, intenta de nuevo.'],
        timeOut: 4
      }));
    }
  };
};

export const startUpdateFechaFinal = (suscripcionId, fechaFinal) => {
  return async (dispatch) => {
    try {
      const resp = await fetchConToken(`suscripciones/${suscripcionId}/fecha-final`, { fechaFinal }, 'PUT');
      const body = await resp.json();

      if (body.ok) {
        dispatch(openModalBottom({
          text: [body.msg || 'Fecha final actualizada correctamente'],
          timeOut: 4
        }));
        
        if (body.suscripcion) {
          dispatch(setSuscripcionActiva(body.suscripcion));
        }
        
        return { ok: true, suscripcion: body.suscripcion };
      } else {
        dispatch(openModalBottom({
          text: [body.msg || 'Error al actualizar la fecha final'],
          timeOut: 4
        }));
        return { ok: false, msg: body.msg };
      }
    } catch (error) {
      console.error('Error actualizando fecha final:', error);
      dispatch(openModalBottom({
        text: ['Error al actualizar la fecha final. Por favor, intenta de nuevo.'],
        timeOut: 4
      }));
      return { ok: false, msg: 'Error de conexión' };
    }
  };
};